module.exports = __webpack_public_path__ + "img/188.2ffef49d.jpg";